module.exports = __webpack_public_path__ + "img/lp_phone.21e4a2cf.png";